import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import ListItemForm from '../ListItemForm';
import ListItemDisplay from '../ListItemDisplay';

export const ListEditor = ({ draft, onChange, consoleId }) => (
  <ListItemForm
    listItems={draft.listItems || []}
    setListItems={(next) => onChange((prev) => ({
      listItems: typeof next === 'function' ? next(prev.listItems || []) : next,
    }))}
    consoleId={consoleId}
  />
);

export const ListViewer = ({ item, onAddListItem, onEditListItem, onDeleteListItem }) => {
  const listItems = item.listItems || [];

  return (
    <div className="space-y-3">
      <div className="flex justify-end">
        <button
          type="button"
          onClick={() => onAddListItem(item._id)}
          className="inline-flex items-center gap-2 rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white hover:bg-green-700"
        >
          <FontAwesomeIcon icon={faPlus} />
          Add list item
        </button>
      </div>

      {listItems.length > 0 ? (
        <div className="grid gap-3 2xl:grid-cols-2">
          {listItems.map((listItem) => (
            <ListItemDisplay
              key={listItem._id}
              listItem={listItem}
              consoleItemId={item._id}
              onEdit={onEditListItem}
              onDelete={onDeleteListItem}
            />
          ))}
        </div>
      ) : (
        <p className="italic text-gray-400">No list items yet. Use "Add list item" to create one.</p>
      )}
    </div>
  );
};
